var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSmsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 21.25c-3.65 0-5.75-2.1-5.75-5.75v-7c0-3.65 2.1-5.75 5.75-5.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H7c-2.86 0-4.25 1.39-4.25 4.25v7c0 2.86 1.39 4.25 4.25 4.25h10c2.86 0 4.25-1.39 4.25-4.25v-4c0-.41.34-.75.75-.75s.75.34.75.75v4c0 3.65-2.1 5.75-5.75 5.75H7z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.659 12.08-3.13-2.5a.748.748 0 0 1 .93-1.17l3.13 2.5c.76.61 2.05.61 2.81 0 .32-.26.79-.21 1.05.12.26.32.21.8-.12 1.05-.64.53-1.49.79-2.33.79-.84 0-1.69-.26-2.34-.79z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.87 9.48c-.33-.24-.84-.84-.54-2.16l.05-.21c.02-.08-.04-.27-.09-.33l-.35-.35c-.59-.6-.82-1.3-.62-1.93.2-.62.79-1.06 1.62-1.2l.38-.06c.07-.02.21-.12.25-.19l.28-.57c.39-.79.99-1.24 1.65-1.24.66 0 1.26.45 1.65 1.24l.28.57c.03.06.18.17.25.19l.38.06c.83.14 1.42.58 1.62 1.2.2.62-.02 1.32-.62 1.93l-.35.35c-.05.06-.11.25-.09.33l.05.21c.3 1.32-.21 1.92-.54 2.16-.33.24-1.05.53-2.2-.16l-.25-.15a.497.497 0 0 0-.34 0l-.26.15c-.54.32-.99.43-1.34.43-.41 0-.69-.14-.87-.27zm2.33-6.33-.28.57c-.24.49-.81.91-1.34 1l-.38.06c-.32.05-.43.16-.44.18 0 .02.03.18.26.41l.35.35c.41.42.62 1.14.49 1.71l-.05.21c-.08.36-.05.55-.03.62.02-.02.2-.04.53-.24l.26-.15c.55-.33 1.34-.33 1.89 0l.25.15c.33.2.5.22.56.22-.01-.03.03-.21-.06-.6l-.05-.21c-.13-.58.08-1.29.49-1.71l.35-.35c.23-.23.26-.39.26-.42-.01-.02-.12-.12-.44-.18l-.38-.06c-.54-.09-1.1-.51-1.34-1l-.28-.56c-.16-.3-.29-.39-.33-.4-.01.01-.15.11-.29.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSmsStar);
export default __webpack_public_path__ + "static/media/vuesax-outline-sms-star.6e601e28850117004879aaf3276a70f1.svg";
export { ForwardRef as ReactComponent };